<template>
  <!--图片全屏预览-->
  <el-dialog :visible.sync="isShow" :fullscreen="true" append-to-body :show-close="true" :close-on-click-modal="true"
    custom-class="full-screen-dialog no-header no-border">
    <div class="preview">
      <div class="close" @click="close"><i class="el-icon-close"></i></div>
      <div class="skip left" :class="{ active: isFirst }" @click="prev"><i class="el-icon-arrow-left"></i></div>
      <img :src="images[index]" />
      <div class="skip right" :class="{ active: isLast }" @click="next"><i class="el-icon-arrow-right"></i></div>
    </div>
  </el-dialog>
</template>

<script>

export default {
  name: "ImagePreview",
  computed: {
    isFirst() {
      if (this.index === 0) return true;
    },
    isLast() {
      if (this.index === this.images.length - 1) return true;
    }
  },
  data() {
    return {
      isShow: false,
      baseUrl: process.env.VUE_APP_BASE_API,
      index: 0,
      images: []
    }
  },
  methods: {
    open(images, index) {
      this.isShow = true;
      this.index = index;
      this.images = [...images];
    },
    close() {
      this.isShow = false;
    },
    prev() {
      if (this.index === 0) return;
      this.index--;
    },
    next() {
      if (this.index === this.images.length - 1) return;
      this.index++;
    }
  }
}
</script>

<style lang="scss" scoped>
.preview {
  position: relative;
  width: 100vw;
  height: 100vh;
  background: black;
}

.preview img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.close {
  background-color: rgba(0, 0, 0, 0.5);
  font-size: 28px;
  cursor: pointer;

  position: absolute;
  top: 5px;
  right: 15px;
}

.skip {
  background-color: rgba(255, 255, 255, 0.5);

  z-index: 10;
  position: absolute;
  top: 50%;

  width: 40px;
  height: 40px;
  border-radius: 20px;
  font-size: 32px;
  color: black;

  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;
  // user-select: none;
}

.skip.left {
  left: 10px;
}

.skip.right {
  right: 13px;
}

//有active类时隐藏箭头
.active {
  display: none;
}
</style>
